<script setup>
import { computed } from 'vue'
import Illustration from './Illustration.vue'
import { ILLUSTRATION_COLOURS } from '@/utils/illustrationColours'

const props = defineProps({
  colour: { type: String, default: 'pink' },  // a key in ILLUSTRATION_COLOURS, or 'random'
})

const colourKeys = Object.keys(ILLUSTRATION_COLOURS)

const resolvedColour = computed(() => (
  props.colour === 'random'
    ? colourKeys[Math.floor(Math.random() * colourKeys.length)]
    : props.colour
))

const set = computed(() => ILLUSTRATION_COLOURS[resolvedColour.value] || ILLUSTRATION_COLOURS.pink)
</script>

<template>
  <div class="vertical-splash" :style="{ background: set.background }">
    <Illustration
      name="vertical-splash"
      :style="{ '--illo-1': set.colour1, '--illo-2': set.colour2 }"
    />
  </div>
</template>

<style lang="scss" scoped>
.vertical-splash {
  display: block;
  width: 100%;
  // Native vertical-splash viewBox ratio (329x465) — see
  // SmallCardTonalSplash.vue for the override/crop-to-fill rationale.
  aspect-ratio: 329 / 465;
  @include rounded($radius);
  overflow: hidden;

  // Same fix as FeatureTonalSplash.vue — stretch Illustration.vue's own
  // inline-block root span so this box's size actually reaches the <svg>.
  :deep(.illustration) {
    display: block;
    width: 100%;
    height: 100%;
  }

  // Scoped under .illustration to out-specify Illustration.vue's own
  // `height: auto` default — see FeatureTonalSplash.vue for the detail.
  :deep(.illustration svg) {
    height: 100%;
  }
}
</style>
